var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 91.6654V16.6654C25 14.4552 25.878 12.3356 27.4408 10.7728C29.0036 9.21 31.1232 8.33203 33.3333 8.33203H66.6667C68.8768 8.33203 70.9964 9.21 72.5592 10.7728C74.122 12.3356 75 14.4552 75 16.6654V91.6654H25Z",
    stroke: "url(#paint0_linear_971_1649)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0026 50H16.6693C14.4591 50 12.3395 50.878 10.7767 52.4408C9.21391 54.0036 8.33594 56.1232 8.33594 58.3333V83.3333C8.33594 85.5435 9.21391 87.6631 10.7767 89.2259C12.3395 90.7887 14.4591 91.6667 16.6693 91.6667H25.0026",
    stroke: "url(#paint1_linear_971_1649)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37.5H83.3333C85.5435 37.5 87.6631 38.378 89.2259 39.9408C90.7887 41.5036 91.6667 43.6232 91.6667 45.8333V83.3333C91.6667 85.5435 90.7887 87.6631 89.2259 89.2259C87.6631 90.7887 85.5435 91.6667 83.3333 91.6667H75",
    stroke: "url(#paint2_linear_971_1649)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6641 25H58.3307",
    stroke: "url(#paint3_linear_971_1649)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6641 41.668H58.3307",
    stroke: "url(#paint4_linear_971_1649)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6641 58.332H58.3307",
    stroke: "url(#paint5_linear_971_1649)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6641 75H58.3307",
    stroke: "url(#paint6_linear_971_1649)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_1649",
    x1: 50,
    y1: 8.33203,
    x2: 50,
    y2: 91.6654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_1649",
    x1: 16.6693,
    y1: 50,
    x2: 16.6693,
    y2: 91.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_971_1649",
    x1: 83.3333,
    y1: 37.5,
    x2: 83.3333,
    y2: 91.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_971_1649",
    x1: 49.9974,
    y1: 25,
    x2: 49.9974,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_971_1649",
    x1: 49.9974,
    y1: 41.668,
    x2: 49.9974,
    y2: 42.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_971_1649",
    x1: 49.9974,
    y1: 58.332,
    x2: 49.9974,
    y2: 59.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_971_1649",
    x1: 49.9974,
    y1: 75,
    x2: 49.9974,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/Companies.e84ad7eb424290b17d39981ae0a8d3c8.svg";
export { ForwardRef as ReactComponent };